import React, { Component } from "react";
import { Form, Input, InputNumber, Select, Button, Carousel, Icon } from "antd";
import styles from "./styles/patientInfoFormCarousel.module.scss";

//data
import { countries, states, distances } from "../../data";

const FormItem = Form.Item;
const Option = Select.Option;

var typing = null;

const PatientInfoFormCarousel = Form.create()(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data: [],
        conditionTyping: false,
        currentSlide: 0
      };
    }
    renderCountryOptions = () => {
      return countries.map(country => {
        return (
          <Option key={country.code} value={country.code}>
            {country.name}
          </Option>
        );
      });
    };
    renderStateOptions = () => {
      return states.map(state => {
        return (
          <Option key={state.code} value={state.code}>
            {state.name}
          </Option>
        );
      });
    };
    renderDistanceOptions = () => {
      return distances.map(distance => {
        return (
          <Option key={distance.code} value={distance.value}>
            {distance.value === 10000 ? "Any Distance" : `${distance.value} Miles` }
          </Option>
        );
      });
    };
    renderDistanceField = getFieldDecorator => {
      return (
        <FormItem>
          <h3 className={styles.stepLabel}>
            How far are you willing to travel?
          </h3>
          {getFieldDecorator("clinicalTrialsDistance", {
            rules: []
          })(
            <Select placeholder="Select a distance">
              {this.renderDistanceOptions()}
            </Select>
          )}
        </FormItem>
      );
    };
    renderCityField = getFieldDecorator => {
      return (
        <FormItem
          style={{ display: "inline-block", width: "49%", marginLeft: "2%" }}
        >
          <h3 className={styles.stepLabel}>City?</h3>
          {getFieldDecorator("clinicalTrialsCity", {
            rules: []
          })(<Input />)}
        </FormItem>
      );
    };
    renderLocationFields = (country, getFieldDecorator) => {
      switch (country) {
        case "US":
          return (
            <div>
              <FormItem style={{ display: "inline-block", width: "49%" }}>
                <h3 className={styles.stepLabel}>State?</h3>
                {getFieldDecorator("clinicalTrialsState", {
                  rules: []
                })(
                  <Select
                    showSearch
                    placeholder="Select a state"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      const currentIndex = input.length;
                      if (
                        option.props.children
                          .substring(0, currentIndex)
                          .toLowerCase() === input.toLowerCase()
                      )
                        return true;
                    }}
                  >
                    {this.renderStateOptions()}
                  </Select>
                )}
              </FormItem>
              {this.renderCityField(getFieldDecorator)}
            </div>
          );
        case undefined:
          return null;
        default:
          return <div>{this.renderCityField(getFieldDecorator)}</div>;
      }
    };
    renderStatesFields = (country, getFieldDecorator) => {
      switch (country) {
        case "US":
          return (
            <FormItem>
              <h3 className={styles.stepLabel}>
                Are there any other states you're willing to travel to?
              </h3>
              {getFieldDecorator("clinicalTrialsExtraStates", {
                rules: []
              })(
                <Select
                  mode="tags"
                  maxTagCount={3}
                  placeholder="Select states (max of 3)"
                  optionFilterProp="children"
                  onChange={value => {
                    if (value.length > 3) value = value.shift();
                  }}
                  filterOption={(input, option) => {
                    const currentIndex = input.length;
                    if (
                      option.props.children
                        .substring(0, currentIndex)
                        .toLowerCase() === input.toLowerCase()
                    )
                      return true;
                  }}
                >
                  {this.renderStateOptions()}
                </Select>
              )}
            </FormItem>
          );
        default:
          return null;
      }
    };

    componentDidUpdate(prevProps, prevState) {
      const { isNew, fetchingValues } = this.props;
      if (!isNew && prevProps.fetchingValues && !fetchingValues)
        this.updateFormFields();
      if (prevState.conditionTyping && !this.state.conditionTyping) {
        var myUrl = `https://clinicaltrials.gov/ct2/rpc/extend/cond?cond=${
          this.state.conditionValue
        }`;
        //  But if you make it from a browser, then it will work without problem ...

        // However to make it work, we are going to use the cors-anywhere free service to bypass this
        var proxy = "https://cors-anywhere.herokuapp.com/";

        // Execute request
        var oReq = new XMLHttpRequest();

        oReq.onreadystatechange = () => {
          if (oReq.readyState === 4) {
            this.setState({ data: oReq.response });
          }
        };
        // Or post, etc
        oReq.responseType = "json";
        oReq.open("GET", proxy + myUrl, true);
        oReq.send();
      }
    }

    updateFormFields = () => {
      const {
        clinicalTrialsCondition,
        clinicalTrialsAge,
        clinicalTrialsGender,
        clinicalTrialsCountry,
        clinicalTrialsState,
        clinicalTrialsCity,
        clinicalTrialsDistance,
        clinicalTrialsExtraStates
      } = this.props.existingValues;
      this.props.form.setFields({
        clinicalTrialsCondition: { value: clinicalTrialsCondition },
        clinicalTrialsAge: { value: clinicalTrialsAge },
        clinicalTrialsGender: { value: clinicalTrialsGender },
        clinicalTrialsCountry: { value: clinicalTrialsCountry }
      });
      setTimeout(() => {
        if (clinicalTrialsCountry === "US")
          this.props.form.setFields({
            clinicalTrialsState: { value: clinicalTrialsState },
            clinicalTrialsCity: { value: clinicalTrialsCity },
            clinicalTrialsDistance: { value: clinicalTrialsDistance },
            clinicalTrialsExtraStates: {
              value: clinicalTrialsExtraStates
            }
          });
        else
          this.props.form.setFields({
            clinicalTrialsCity: { value: clinicalTrialsCity },
            clinicalTrialsDistance: { value: clinicalTrialsDistance }
          });
      }, 100);
    };

    onChangeCondition = value => {
      this.setState({ conditionTyping: true, conditionValue: value });
      if (typing != null) {
        clearTimeout(typing);
        typing = null;
      } else {
        typing = setTimeout(() => {
          this.setState({ conditionTyping: false });
        }, 200);
      }
    };

    nextQuestion = () => {
      setTimeout(() => this.refs.carousel.next(), 300);
    };

    onSlideChange = (from, to) => {
      this.setState({ currentSlide: to });
      this.props.onSlideChange(to);
    };

    render() {
      const { handleSubmit, form, loading } = this.props;
      const { getFieldDecorator } = form;
      const country = form.getFieldValue("clinicalTrialsCountry");
      const options = this.state.data.map(d => <Option key={d}>{d}</Option>);
      return (
        <Form
          onSubmit={e => {
            this.refs.carousel.next();
          }}
        >
          <Carousel
            ref="carousel"
            horizontal
            beforeChange={(from, to) => this.onSlideChange(from, to)}
          >
            <FormItem>
              <h3 className={styles.stepLabel}>
                What condition are you looking to find a clinical trial for?
              </h3>
              {getFieldDecorator("clinicalTrialsCondition", {
                rules: []
              })(
                <Select
                  showSearch
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  onSearch={this.onChangeCondition}
                  notFoundContent={null}
                  onChange={this.nextQuestion}
                >
                  {options}
                </Select>
              )}
            </FormItem>

            <FormItem style={{ display: "inline-block", width: "35%" }}>
              <h3 className={styles.stepLabel}>How old are you?</h3>
              {getFieldDecorator("clinicalTrialsAge", {
                rules: []
              })(
                <InputNumber
                  min={0}
                  max={120}
                  style={{ width: "100%" }}
                  onPressEnter={this.nextQuestion}
                />
              )}
            </FormItem>

            <FormItem style={{ display: "inline-block", width: "65%" }}>
              <h3 className={styles.stepLabel}>What is your gender?</h3>
              {getFieldDecorator("clinicalTrialsGender", {
                rules: []
              })(
                <Select
                  placeholder="Select a gender"
                  onChange={this.nextQuestion}
                >
                  <Option value="Male">Male</Option>
                  <Option value="Female">Female</Option>
                  <Option value="All">Other</Option>
                </Select>
              )}
            </FormItem>

            <FormItem>
              <h3 className={styles.stepLabel}>
                What country do you reside in?
              </h3>
              {getFieldDecorator("clinicalTrialsCountry", {
                rules: []
              })(
                <Select
                  showSearch
                  placeholder="Select a country"
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const currentIndex = input.length;
                    if (
                      option.props.children
                        .substring(0, currentIndex)
                        .toLowerCase() === input.toLowerCase()
                    )
                      return true;
                  }}
                  onChange={this.nextQuestion}
                >
                  {this.renderCountryOptions()}
                </Select>
              )}
            </FormItem>
            <div>{this.renderLocationFields(country, getFieldDecorator)}</div>
            <div>{this.renderDistanceField(getFieldDecorator)}</div>
            <div>{this.renderStatesFields(country, getFieldDecorator)}</div>
          </Carousel>
          <div>
            {this.state.currentSlide !== 0 ? (
              <Button
                type="primary"
                size="large"
                onClick={() => this.refs.carousel.prev()}
              >
                <Icon type="left" />Prev
              </Button>
            ) : null}
            {this.state.currentSlide === 6 ? (
              <Button
                type="primary"
                size="large"
                onClick={e => handleSubmit(e, form)}
                style={{ float: "right" }}
                loading={loading}
              >
                Get Results
              </Button>
            ) : (
              <Button
                type="primary"
                size="large"
                onClick={() => this.refs.carousel.next()}
                style={{ float: "right" }}
              >
                Next<Icon type="right" />
              </Button>
            )}
          </div>
          {!this.props.isNew ? (
            <div className={styles.skipForm}>
              <p>Returning user?</p>
              <Button
                type="primary"
                size="medium"
                onClick={e => handleSubmit(e, form)}
              >
                View Active Report
              </Button>
            </div>
          ) : null}
        </Form>
      );
    }
  }
);

export { PatientInfoFormCarousel };



// WEBPACK FOOTER //
// ./src/components/forms/PatientInfoFormCarousel.js